import React from 'react';
import IShowCaseTypes from '../../models/IShowCaseTypes';
import "../../assets/scss/project/project-showcase-text.scss"
import { Col, Container, Row } from 'react-bootstrap';


export interface IText extends IProps {
    type: IShowCaseTypes.text;
}

export interface IProps {
    text: {
        title?: string | undefined;
        quote?: string | undefined;
        paragraphs?: string[] | undefined;
    }
}

function ProjectShowCaseText(props: IProps) {

    const title = () => {
        if (props.text.title !== undefined) {
            return <h1>{props.text.title}</h1>
        }
    }

    const quote = () => {
        if (props.text.quote !== undefined) {
            return <p className="quote">{props.text.quote}</p>
        }
    }

    const paragraphs = props.text.paragraphs !== undefined ? props.text.paragraphs.map((paragraph: string, index: number) => {
        return (
            <p className="paragraph" key={index}>
                {paragraph}
            </p>
        )
    }) : null;


    return (
        <Container>
            <Row>
                <Col ms={12} md={{ offset: 2, span: 10 }} lg={{ offset: 4, span: 8 }} xl={{ offset: 5, span: 7 }}>
                    <div className="showcase-text">
                        {title()}
                        {quote()}
                        {paragraphs}
                    </div>
                </Col>
            </Row>
        </Container>
    );
}

export default ProjectShowCaseText;